export default __webpack_public_path__ + "static/media/qrcode.065b8ae2.svg";